import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import CreateEditUser from '../../components/CreateEditUser';
import ProjectUser from '../../components/ProjectUser';
import Inventory from '../../components/Inventory';
import useApi from '../../api/useApi';
import { roles } from '../../Constants';
import Notification from '../../components/Notification';
import '../../scrollbar.css';

function Table() {
  // const location = useLocation();
  const [openCreate, setOpenCreate] = useState(false);
  const [openProject, setOpenProject] = useState(false);
  const [{ isLoading, isError, data }, getData] = useApi();
  const [users, setUsers] = useState([]);
  const [onClose, setOnClose] = useState(false);
  const [selectedUser, selectUser] = useState([]);
  const [selectedId, setSelectedId] = useState({ id: '', name: '' });
  const [state, deleteUser] = useApi();
  const [action, setAction] = useState('');
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [formData, setFormData] = useState({ q: '', status: '' });
  const [filteredData, setFilteredData] = useState([]);
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const user = localStorage.getItem('user');
  const day = 1000*60*60*24;
  let orgId;
  if (!user) {
    location.href = '/';
  } else {
    orgId = user && JSON.parse(localStorage.user).organization.id;
  }

  useEffect(() => {
    user && getData(`/organization/${orgId}/users`, 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      const _users = data.users.sort((a, b) => (a.userName.toLowerCase() > b.userName.toLowerCase() ? 1 : -1));
      setUsers(_users);
      setFilteredData(_users);
    }
    if (isError) {
      setType('error');
      setMessage('Unable to fetch user');
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  const toggleOpenCreate = () => {
    setOpenCreate((prev) => !prev);
  };

  const toggleOpenProject = () => {
    setOpenProject((prev) => !prev);
  };

  const getRole = (roleCode) => {
    const x = roles.filter((role) => role.id == roleCode);
    return x[0].value;
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  const handleDelete = () => {
    deleteUser(`/user/${selectedUser[0].id}`, 'DELETE');
  };

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setType('success');
      setMessage('User deleted successfully');
      setOnClose(false);
      setNotification(!notification);
      getData(`/organization/${orgId}/users`, 'GET');
    }

    if (state.isError) {
      setType('error');
      setMessage('Unable to delete user');
      setNotification(!notification);
    }
  }, [state]);

  useEffect(() => {
    if (filteredData.length <= 0) {
      return;
    }

    let z = filteredData;

    if (formData.q === '' && formData.status === '') {
      setUsers(filteredData);
    }
    if (formData.q) {
      z = z.filter((x) => {
        const normalizedQuery = formData.q.toLowerCase();
        return (
          x?.userName?.toLowerCase().indexOf(normalizedQuery) >= 0 ||
          x?.email?.toLowerCase().indexOf(normalizedQuery) >= 0
        );
      });
    }
    if (formData.status) {
      z = z.filter((x) => x?.isActive.toString() === formData.status);
    }
    if (z.length > 0) setUsers(z);
    else setUsers([]);
  }, [formData]);

  const refreshList = () => {
    getData(`/organization/${orgId}/users`, 'GET');
    toggleOpenCreate();
  };

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    const timeZoneOffset = _date.getTimezoneOffset();
    const _timestamp = _date.getTime() - timeZoneOffset * 60 * 1000;
    if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
      return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    }

    if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
      return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    }

    if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
      return `${Math.round(
        ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
      )} minutes ago`;
    }

    return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;

    // Math.round(((diffMs % 86400000) % 3600000) / 60000);
  };

  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20 px-16"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white px-16 text-xl block m-auto rounded-2xl">
            <span className="block text-center mt-10 mb-8">Do you want to delete user {selectedId.name}?</span>
            <div className="flex justify-center items-center mb-10 font-bold">
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-10 py-4 rounded-lg text-sm mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={handleDelete}
              >
                YES
              </button>
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-10 py-4 rounded-lg text-sm mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setOnClose(false);
                }}
              >
                NO
              </button>
            </div>
          </div>
        </div>
      )}
      {openCreate && (
        <CreateEditUser
          handleClose={toggleOpenCreate}
          action={action}
          notification={createNotification}
          selectedUser={selectedId.id}
          refreshList={() => refreshList()}
        />
      )}

      {openProject && (
        <ProjectUser
          handleClose={toggleOpenProject}
          action={action}
          notification={createNotification}
          selectedUser={selectedUser}
          refreshList={() => refreshList()}
        />
      )}

      {location.pathname === '/inventory' && <Inventory />}
      <div
        className="h-full w-topBar fixed hideScroll"
        style={{
          filter: (openCreate || location.pathname === '/inventory') && 'blur(2px)',
          left: '12%',
          width: '88%',
          overflow: 'auto',
        }}
      >
        <div className="z-50" style={{ height: '22vh', background: '#f9f9f9', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-xl">Users</span>

            <div className="block lg:flex mt-1 lg:mt-0">
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCreate();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                CREATE
              </button>
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('update');
                  if (selectedUser[0]) toggleOpenCreate();
                }}
              >
                <img src="assets/img/Edit.svg" className="h-3 mr-2 " alt="" />
                EDIT
              </button>
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  if (selectedId.id) setOnClose(true);
                }}
              >
                <img src="assets/img/Delete.svg" className="h-3 mr-2 " alt="" />
                DELETE
              </button>

              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  if (selectedUser.length > 0) toggleOpenProject();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                ADD USER TO PROJECT
              </button>

              <div className="mt-1 lg:mt-0 w-full lg:w-max border bg-transparent px-4 rounded-sm ml-3 flex justify-between items-center rounded-md">
                <input
                  type="text"
                  placeholder="Search User"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                />
                <img src="assets/img/Search.png" className="h-4 ml-2 " alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl" style={{ minWidth: '700px' }}>
          <div className="bg-tableBg w-tableWidth m-auto mb-3">
            <div className="bg-tableHeader w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-6 flex w-full relative">
                <div className=" py-4 px-4 text-left text-sm font-bold" style={{ width: `${100 / 7}%` }}>
                  NAME
                </div>
                <div className=" py-4 px-4 text-left text-sm font-bold" style={{ width: `${100 / 7}%` }}>
                  SHORT NAME
                </div>
                <div className=" py-4 px-4 text-left text-sm font-bold" style={{ width: `${100 / 7}%` }}>
                  EMAIL
                </div>
                <div className=" py-4 px-4 text-left text-sm font-bold" style={{ width: `${100 / 7}%` }}>
                  CONTACT
                </div>
                <div className=" py-4 px-4 text-left text-sm font-bold" style={{ width: `${100 / 7}%` }}>
                  ROLE
                </div>
                <div className="py-2 px-4 text-left text-sm font-bold" style={{ width: `${100 / 7}%` }}>
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-4 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#648299"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.status}
                      name="status"
                      className="border-2 font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-10 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-xl"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">STATUS</option>
                      <option value="true">ACTIVE</option>
                      <option value="false">INACTIVE</option>
                    </select>
                  </div>
                </div>
                <div className=" py-4 px-4 text-left text-sm font-bold" style={{ width: `${100 / 7}%` }}>
                  LAST MODIFIED
                </div>
                {/* <div className=" py-4 px-4 text-left text-sm font-bold" style={{ width: `${100 / 7}%` }}>
                  STATUS
                </div> */}
                {/* <div className=" py-4 px-4 text-left text-sm font-bold" style={{ width: `${100 / 7}%` }}>
                  AVATAR
                </div> */}
              </div>
            </div>

            {!isLoading ? (
              <div
                className="pb-1 border hideScroll"
                style={{ borderColor: '#e6e6e6', height: '77vh', overflow: 'auto' }}
              >
                {users.map((item) => (
                  <div className="m-2.5 px-4 bg-white flex rounded-md  shadow-sm relative border-2 border-transparent hover:border-indigo-200 focus-within:border-indigo-200">
                    <input
                      type="checkbox"
                      className="absolute left-3 top-5"
                      onChange={() => {
                        setSelectedId({ id: item.id, name: item.userName });
                        selectUser((prev) => [...prev, item]);
                      }}
                      // checked={selectedUser[0].id === item.id}
                    />

                    <div
                      className="text-role py-4 px-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm flex px-2"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {item?.userName}
                    </div>
                    <div
                      className="text-role py-4 px-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {item?.slug}
                    </div>
                    <div
                      className="text-role py-4 px-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {item?.email}
                    </div>
                    <div
                      className="text-role py-4 px-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {item?.contact}
                    </div>
                    <div
                      className="text-role py-4 px-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {getRole(item?.role)}
                    </div>

                    <div
                      className="text-role py-4 px-4 pl-12 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {item?.isActive ? 'ACTIVE' : 'INACTIVE'}
                    </div>
                    <div
                      className="text-role py-4 px-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {getTimeoffset(item?.updatedAt)}
                      {/* {Math.round((Date.now() - new Date(item?.updatedAt).getTime()) / day) !== 0 ? `${Math.round((Date.now() - new Date(item?.updatedAt).getTime()) / day)} Days Ago` : `${parseInt(Math.abs(Date.now() - new Date(item?.updatedAt).getTime()) / 36e5)} Hours Ago`} */}
                      {/* {new Date(item?.updatedAt).getDay() === 0 ? `${new Date(item?.updatedAt).getHours()} Hours Ago` : `${new Date(item?.updatedAt).getDay()} Days Ago`} */}
                    </div>
                    {/* <div
                      className="text-role py-4 px-4 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-sm uppercase"
                      style={{ width: `${100 / 7}%` }}
                    >
                      {' '}
                      {item?.avatar}
                    </div> */}
                  </div>
                ))}
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Table;
